// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"9dd515a1","149":"0d6b00a1","189":"e65d95ba","424":"b841037b","490":"e26ed671","518":"da4d77e9","667":"0e101601","781":"53514580","872":"bcb716cc"}[chunkId] + ".chunk.js";
};